<template>
  
  <div class="Chart">
    
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Wykres
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div class="content">
          
          <div id="graphdiv" class="graphdiv"></div>
        </div>
      </div>
      <footer class="card-footer">
        <div class="container is-widescreen">
          <div class="columns  is-mobile">
            
            <div class="column">
                <label class="checkbox">
                  <input id="cb__0"  checked="checked" type="checkbox" class="checkbox-input"> 1
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__1"  checked="checked" type="checkbox" class="checkbox-input"> 2
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__2"  checked="checked" type="checkbox" class="checkbox-input"> 3
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__3"  checked="checked" type="checkbox" class="checkbox-input"> 4
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__4"  checked="checked" type="checkbox" class="checkbox-input"> 5
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__5"  checked="checked" type="checkbox" class="checkbox-input"> 6
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__6"  checked="checked" type="checkbox" class="checkbox-input"> 7
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__7"  checked="checked" type="checkbox" class="checkbox-input"> 8
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__8"  checked="checked" type="checkbox" class="checkbox-input"> 9
              </label>
            </div>
            <div class="column">
                <label class="checkbox">
                  <input id="cb__9"  checked="checked" type="checkbox" class="checkbox-input"> 10
              </label>
            </div>
            <div class="column">
              
            </div>
            <div class="column">
              <div class="control">
                <button @click="range_1" class="button is-link is-small is-light">1 dzień</button>
              </div>
            </div>
            <div class="column">
              <div class="control">
                  <button @click="range_7" class="button is-link is-small is-light">7 dni</button>
                </div>
              </div>
            <div class="column">
                <div class="control">
                  <button @click="range_14" class="button is-link is-small is-light">14 dni</button>
                </div>
            </div>
          </div>
        </div>
        
      </footer>
      
    </div>
    
   
  </div>
</template>

<script>

import Dygraph from 'dygraphs';
//import axios from 'axios'

export default {
  name: 'Chart',
  props: {
    
    
  },
  data() {
    return {
      chartData: [],
      lines: [1,1,1,1,1,1,1,1,1,1]
    }
  },
  mounted () {
    
    this.init_checkboxes();
    this.getRange(1);

  },
  computed: {

    
  },
  watch: {
    
  },
  updated() {
    
    
  },
  methods: {
      range_1(){
        this.getRange(1);
      },
      range_7(){
        this.getRange(7);
      },
      range_14(){
        this.getRange(14);
      },
      getRange(_range){

        //this.range = _range;
        if (_range == 1){
          this.range_str = "1 dzień"
        }else if (_range == 3){
          this.range_str = "3 dni"
        }else if (_range == 7){
          this.range_str = "7 dni"
        }
        
        let objData = {
            range: _range,

        }
        
        this.$store.dispatch('getRange', objData)
        .then(response => {
          
          
          this.chartData = response.data;
          this.buildChart(this.chartData);
        })
        .catch(error => {
            console.log("Error:")
            console.log(error)
            
        });
      },
      init_checkboxes(){

        let vue = this;

        let checkboxes = document.getElementsByClassName("checkbox-input");


        for (let i = 0, lei = checkboxes.length; i < lei; i++){

        
          checkboxes[i].addEventListener('change', function() {
            
            let temp = this.id.split("__");

            if (this.checked) {
              
              
              vue.setLine(temp[1], 1)
            } else {
             
              vue.setLine(temp[1], 0)
            }
            
            
          });
        }
      },
      setLine(index, status){
        
        for (let i = 0, lei = this.lines.length; i < lei; i++) {
          if (i == index){
            this.lines[i] = status;
          }

        }
        
        this.buildChart(this.chartData);
      },
      buildChart(data){
        
        var le = data.length;
        
        if (le > 0){
          var tab = [];
          for (var i = 0; i < le; i++) {
            
            var d = new Date(Date.parse(data[i].date));
            var t0 = (parseFloat(data[i].t0));
            var t1 = (parseFloat(data[i].t1));
            var t2 = (parseFloat(data[i].t2));
            var t3 = (parseFloat(data[i].t3));
            var t4 = (parseFloat(data[i].t4));
            var t5 = (parseFloat(data[i].t5));
            var t6 = (parseFloat(data[i].t6));
            var t7 = (parseFloat(data[i].t7));
            var t8 = (parseFloat(data[i].t8));
            var t9 = (parseFloat(data[i].t9));
            tab.push([d, t0, t1, t2, t3, t4, t5, t6, t7, t8, t9]);
          }

          
          let  colors1 = [
              'rgba(0, 153, 255, 1)',
              'rgba(0, 204, 0, 1)',
              'rgba(204, 0, 0, 1)',
              'rgba(255, 204, 0, 1)',
              'rgba(204, 102, 255, 1)',
              'rgba(211, 129, 7, 1)',
              'rgba(129, 1, 7, 1)',
              'rgba(234, 181, 25, 1)',
              'rgba(222, 25, 234, 1)',
              'rgba(95, 129, 42, 1)'
              ]  
          let  colors2 = [
              'rgba(0, 153, 255, 0.1)',
              'rgba(0, 204, 0, 0.1)',
              'rgba(204, 0, 0, 0.1)',
              'rgba(255, 204, 0, 0.1)',
              'rgba(204, 102, 255, 0.1)',
              'rgba(211, 129, 7, 0.1)',
              'rgba(129, 1, 7, 0.1)',
              'rgba(234, 181, 25, 0.1)',
              'rgba(222, 25, 234, 0.1)',
              'rgba(95, 129, 42, 0.1)'
              ] 
          let colors  = [];
          for (var i = 0, lei = this.lines.length; i < lei; i++) {
            
            if (this.lines[i] == 1){
              colors[i] = colors1[i];
            }else{
              colors[i] = colors2[i];
            }
            
          }

          new Dygraph('graphdiv', tab, {
            //legend: 'always'
            
              ylabel: 'T (C)',
              valueRange: [10, 80],
            showRangeSelector: true
            , labels: [
                  'Czas', 
                  '1.CO zasilanie 1', 
                  '2.CO zasilanie 2', 
                  '3.CO powrót 1', 
                  '4.CO powrót 2', 
                  '5.CW na budynek', 
                  '6.CW na zasobnik z kotła',
                  '7.CW cyrkulacja',
                  '8.Kol-zejście glikolu',
                  '9.Kol-cyrkulacja',
                  '10.Kol-CWZ wymiennika',
            ]
            , strokeWidth: 2
            //, includeZero:true
            , colors: colors
              
          });
        }
        
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card{
    margin-top: 10px;
  }
  .graphdiv{
    width: auto;
    height: 250px;
  }
  .dygraph-legend{
    float: right;
    font-size: 9px;
  }
  .dygraph-ylabel{
    
    float:right;
  }
  .card{
    color: #ffffff;
  }
  .button{
    margin: 5px;
  }
</style>
